module.exports = __webpack_public_path__ + "static/statix-523fd596cae4c9d5c9564f264b376699.jpg";